import script from "./ShareCoursewareModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareCoursewareModal.vue?vue&type=script&setup=true&lang=ts"

export default script